import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const clubUserLoggedInReducer = (
  state = initialState.clubUserLoggedIn,
  action
) => {
  switch (action.type) {
    case types.CLUB_USER_LOGIN:
      return true;

    case types.CLUB_USER_LOGOUT:
      return false;

    default:
      return state;
  }
};

export const clubPricesInterestingReducer = (
  state = initialState.isClubPricesInterested,
  action
) => {
  switch (action.type) {
    case types.CLUB_PRICES_INTERESTING:
      return action.payload;
    default:
      return state;
  }
};

export const clubUserDataReducer = (
  state = initialState.clubUserData,
  action
) => {
  switch (action.type) {
    case types.CLUB_USER_LOGIN:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/discountClubReducer.js